const IMAGES = {
  r: {
    liveChatImage: 'assets/images/live-chat-rogers.png',
    VaImage: 'assets/images/rogers-anna-icon-head.png',
    floatingImage: 'assets/images/rogers-chat-icon.svg',
  },
  f: {
    liveChatImage: 'assets/images/fido house.png',
    VaImage: 'assets/images/fido-jack-head.svg',
    floatingImage: 'assets/images/fido-jack-head.svg',
  },
  s: {
    liveChatImage: 'assets/images/live-chat-rogers.png',
    VaImage: 'assets/images/shaw-icon.svg',
    floatingImage: 'assets/images/shaw-icon.svg',
  },
};

export function getChatHeaderLogoImage(
  isLiveChat: boolean,
  realm: string,
  isFloatingButton?: boolean
): string {
  if (isFloatingButton) {
    return IMAGES[realm].floatingImage;
  }
  if (isLiveChat) {
    return IMAGES[realm].liveChatImage;
  }
  return IMAGES[realm].VaImage;
}
